var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.viewEdit)?_c('design'):_vm._e(),(!_vm.viewEdit)?[_c('preview')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }